import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/presentation/components/select'
import { cn } from '@/presentation/utils'
import type { AutoFormWidgetsProps } from '../autoForm'
import { Field } from '../field'
import { FieldControl } from '../fieldControl'
import { FieldLabel } from '../label'
import { FieldMessage } from '../message'

type SelectItemValue = {
  value: string
  label: string
}

export const SelectWidget = (props: AutoFormWidgetsProps) => {
  return (
    <Field path={props.path} className={props.classNames?.root}>
      <FieldLabel>{props.options?.label as string}</FieldLabel>
      <Select name={props.path} defaultValue={props.initialValue}>
        <FieldControl>
          <SelectTrigger>
            <SelectValue placeholder={props.options?.placeholder as string} />
          </SelectTrigger>
        </FieldControl>
        <SelectContent className="z-[100]">
          {((props.options?.values as SelectItemValue[]) || []).map(
            (value: SelectItemValue, index: number) => (
              <SelectItem key={`${props.path}-${value.value}-${index}`} value={value.value}>
                {value.label}
              </SelectItem>
            ),
          )}
        </SelectContent>
      </Select>
      <FieldMessage />
    </Field>
  )
}
